export default "__VITE_ASSET__BLPEwzmK__"